export default {
	"logs.log-timestamp": "Log Timestamp",
	"logs.category": "Category",
	"logs.message": "Message",
	"logs.upos-version": "Version",
	"logs.device-ip": "Device IP",
	"logs.outlet-id": "Outlet ID",
	"logs.outlet-name": "Outlet Name",
	"logs.terminal-id": "Terminal No",
	"logs.distinct-only": "Distinct Only"
};
